module.exports = __webpack_public_path__ + "img/bjj.ebb9813b.png";